import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import CommonModalHeader from '../../../../../components/DialogUi/CommonModalHeader';

interface Props {
  openDelete: boolean;
  setOpenDelete: any;
  deleteLoader: boolean;
  handeleDeleteMatch: any;
}

const MatchDeleteDialog = ({ openDelete, setOpenDelete, deleteLoader, handeleDeleteMatch }: Props) => {
  return ( 
    <Dialog
      open={openDelete}
      onClose={() => setOpenDelete(false)}
      fullWidth
    >
      <CommonModalHeader 
        title={`Remove Match`}
        handleCloseModal={() => setOpenDelete(false)}
      />
      <DialogContent style={{backgroundColor: 'black'}}>
        <Typography variant='h5' textAlign={'center'}>
          Are you sure you want to <br/> remove this match?
        </Typography>
      </DialogContent>
      <DialogActions style={{backgroundColor: 'black'}}>
        <Button
          fullWidth
          // color='error'
          // variant='outlined'
          onClick={() => setOpenDelete(false)}
          sx={{
                height: '48px !important',
                borderRadius: '6px !important',
                background: '#565656 !important',
                textTransform: 'none !important',
                fontSize: '14px !important',
                fontWeight: '700 !important',
                color: 'white !important'
              }}
        >
          Cancel
        </Button>
        <LoadingButton
          fullWidth
          color="primary"
          variant='contained'
          loading={deleteLoader}
          onClick={handeleDeleteMatch}
          sx={{
                height: '48px !important',
                borderRadius: '6px !important',
                background: 'linear-gradient(180deg, #F79420 0%, #F15A26 100%) !important',
                textTransform: 'none !important',
                fontSize: '14px !important',
                fontWeight: '700 !important',
                color: 'white !important'
              }}
        >
          Remove match
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default MatchDeleteDialog;
